import {
  Row,
  Loader,
  Column,
  ActionBar,
  Container,
  useApi,
} from "lcm-iot-commons";

import { useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import DocumentForm from "../Documents/DocumentForm";

export default function AttachmentAdd() {
  const api = useApi();
  // @ts-expect-error TS(2339) FIXME: Property 'documentId' does not exist on type '{}'.
  const { documentId } = useParams();
  const { data: document, isLoading } = api.get.useQuery(
    `/documents/${documentId}`,
    { include: "attachments,categories" },
  );

  const initialValues = document
    ? {
        name: (document as $TSFixMe).name,
        category: {
          name:
            (document as $TSFixMe).categories?.length > 0
              ? (document as $TSFixMe).categories[0].name
              : "-",
        },
        validFrom: (document as $TSFixMe).valid_from
          ? (document as $TSFixMe).valid_from
          : "-",
        validUntil: (document as $TSFixMe).valid_until
          ? (document as $TSFixMe).valid_until
          : "-",
        version: (document as $TSFixMe).document_version
          ? (document as $TSFixMe).document_version
          : "-",
        attachments:
          (document as $TSFixMe).attachments?.length > 0
            ? (document as $TSFixMe).attachments
            : [],
      }
    : undefined;

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <h1>
              <FormattedMessage id="attachment_add.header" />
            </h1>
          </ActionBar>
        </Column>
      </Row>
      <Row>
        <Column lg="7">
          {/* @ts-expect-error TS(2322) FIXME: Type 'unknown' is not assignable to type 'ReactNod... Remove this comment to see the full error message */}
          {document && <DocumentForm addMode initialValues={initialValues} />}
        </Column>
      </Row>
      <Loader loading={isLoading} />
    </Container>
  );
}
